mutation NewMessageApprovalCreate($input: MessageApprovalCreateInput!) {
  messageApprovalCreate(input: $input) {
    userMessages {
      id
      messageComment
    }
  }
}
